import { Responsive, styleVariables } from '@lib/common';
import { Card, Space, Typography } from 'antd';
import styled from 'styled-components';
import { AssignmentStatusComponent, getDateTime, getTimeStr } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var CardItemLayout = styled(Space).withConfig({
  displayName: "mobile-attendee-submissioncomponent__CardItemLayout",
  componentId: "sc-v0b3ce-0"
})(["display:flex;justify-content:space-between;margin-bottom:12px;"]);
var CardItemTitle = styled(Typography).withConfig({
  displayName: "mobile-attendee-submissioncomponent__CardItemTitle",
  componentId: "sc-v0b3ce-1"
})(["font-size:12px;font-weight:400;color:", ";"], styleVariables.colors.gray11);
var CardItemContent = styled(Typography).withConfig({
  displayName: "mobile-attendee-submissioncomponent__CardItemContent",
  componentId: "sc-v0b3ce-2"
})(["font-size:12px;font-weight:500;color:", ";"], styleVariables.colors.gray13);
var StyledResultRow = styled.span.withConfig({
  displayName: "mobile-attendee-submissioncomponent__StyledResultRow",
  componentId: "sc-v0b3ce-3"
})(["display:flex;"]);
var StyledCard = styled(Card).withConfig({
  displayName: "mobile-attendee-submissioncomponent__StyledCard",
  componentId: "sc-v0b3ce-4"
})(["margin-bottom:16px;box-shadow:0px 1px 6px rgba(0,0,0,0.12);border-radius:8px;border:0;"]);
export var MobileAttendeeSubmissionComponent = function MobileAttendeeSubmissionComponent(_ref) {
  var attendeeSubmissionTranslation = _ref.attendeeSubmissionTranslation,
      submissions = _ref.submissions,
      onOpenReview = _ref.onOpenReview;
  return /*#__PURE__*/_jsx(Responsive.MobileScreen, {
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: submissions.map(function (record) {
        var _result$status;

        var createdAt = record.createdAt,
            elapsedTime = record.elapsedTime,
            result = record.result,
            totalQuestions = record.totalQuestions;
        return /*#__PURE__*/_jsxs(StyledCard, {
          onClick: function onClick() {
            return onOpenReview(record);
          },
          children: [/*#__PURE__*/_jsxs(CardItemLayout, {
            children: [/*#__PURE__*/_jsx(CardItemTitle, {
              children: attendeeSubmissionTranslation.startEndDate
            }), /*#__PURE__*/_jsx(CardItemContent, {
              children: createdAt ? getDateTime(+createdAt / 1000) : '-'
            })]
          }), /*#__PURE__*/_jsxs(CardItemLayout, {
            children: [/*#__PURE__*/_jsx(CardItemTitle, {
              children: attendeeSubmissionTranslation.duration
            }), /*#__PURE__*/_jsx(CardItemContent, {
              children: getTimeStr(elapsedTime, {
                h: attendeeSubmissionTranslation.hour,
                m: attendeeSubmissionTranslation.minute,
                s: attendeeSubmissionTranslation.second
              }) || '-'
            })]
          }), /*#__PURE__*/_jsxs(CardItemLayout, {
            children: [/*#__PURE__*/_jsx(CardItemTitle, {
              children: attendeeSubmissionTranslation.correctPercent
            }), /*#__PURE__*/_jsx(CardItemContent, {
              children: (result === null || result === void 0 ? void 0 : result.expectationResult) !== null ? /*#__PURE__*/_jsxs(StyledResultRow, {
                children: [/*#__PURE__*/_jsx(AssignmentStatusComponent, {
                  statusType: result === null || result === void 0 ? void 0 : (_result$status = result.status) === null || _result$status === void 0 ? void 0 : _result$status.id,
                  text: "".concat(result === null || result === void 0 ? void 0 : result.expectationResult, "%")
                }), "\xA0(", result === null || result === void 0 ? void 0 : result.numberOfCorrectAnswers, "/", totalQuestions, "\xA0", attendeeSubmissionTranslation.correctAnswer, ")"]
              }) : '-'
            })]
          }), /*#__PURE__*/_jsxs(CardItemLayout, {
            children: [/*#__PURE__*/_jsx(CardItemTitle, {
              children: attendeeSubmissionTranslation.result
            }), /*#__PURE__*/_jsx(CardItemContent, {
              children: /*#__PURE__*/_jsx(StyledResultRow, {
                children: result !== null && result !== void 0 && result.status ? /*#__PURE__*/_jsx(AssignmentStatusComponent, {
                  statusType: result.status.id,
                  text: result.status.name
                }) : '-'
              })
            })]
          })]
        }, record.id.toString());
      })
    })
  });
};